(ns admin.components.composite.questionnaire.messaging-form
  (:require
   [reagent-form.core :as rf]
   [reagent-form.transformers :as t]
   [re-frame.core :as re-frame]

   [kyber.components.base.text :as text]
   [kyber.styles.core :refer [gs styles->classes]]
   [admin.router.utils :as aru]))

(def classes
  (styles->classes
   {:settings-form-container
    {:padding (gs [:spacing :p20])
     :box-shadow (gs [:shadows :shadow-12])
     :margin :auto
     :max-width "1000px"}}))

(defn render
  [{:keys [activity-uuid
           questionnaire
           questionnaire-api
           questionnaire-type
           questionnaire-is-updating
           curriculum-uuid]} nq]
  (let [[pass-message fail-message messaging-confirmed?]
        (mapv #((nq %) questionnaire) [:pass-message :fail-message :messaging-confirmed?])

        update-questionnaire-event
        (:questionnaire-update-event questionnaire-api)

        post-update-nav-to-url
        (aru/admin-path :activity-assessments
                        :curriculum-uuid curriculum-uuid
                        :activity-uuid activity-uuid
                        :question-step "questions")

        pass-label (if (= questionnaire-type :evaluation)
                     "Message presented after SUBMITTING the evaluation"
                     "Message presented after PASSING the test")

        text-caption (if (= questionnaire-type :evaluation)
                       (str "Provide a message that will be displayed to the learner after "
                            "they have submitted the evaluation.")
                       (str "Provide a message that will be displayed to the learner after "
                            "they have completed the test. You can provide different "
                            "messages for the learners who pass and fail."))

        questionnaire-success-toast (if (= questionnaire-type :evaluation)
                                      "Evaluation updated!"
                                      "Boost updated!")

        questionnaire-failure-toast (if (= questionnaire-type :evaluation)
                                      "Failed to update evaluation."
                                      "Failed to update boost.")]
    [:div {:class (:settings-form-container classes)}
     [text/title-30 :p (case questionnaire-type
                         :assessments "Post-Test Messaging (Optional)"
                         :floating "Questionnaire Message (Optional)"
                         :evaluation "Evaluation Message (Optional)"

                         (js/console.error "Test type not supported"))]
     [text/caption-10 :p
      {:style {:max-width "600px"}}
      text-caption]

     [rf/form {:id :questionnaire-messaging
               :is-submitting questionnaire-is-updating}
      [:form
       {:rf/form
        {:on-submit #(if (= questionnaire-type :assessments)
                       (re-frame/dispatch
                        [update-questionnaire-event
                         (cond-> (assoc % :activity/uuid activity-uuid
                                          :assessment/messaging-confirmed? true)
                           (false? ((nq :confidence-threshold-enabled?) %))
                           (dissoc (nq :confidence-threshold))

                           (nil? ((nq :pre-test-pass-percent) %))
                           (dissoc (nq :pre-test-pass-percent)))
                         {:response-keys [:activity/uuid
                                          {:activity/assessment [:assessment/pass-message
                                                                 :assessment/fail-message
                                                                 :assessment/messaging-confirmed?]}]
                          :on-success-toast  "Assessment updated."
                          :on-failure-toast "Failed to update your assessment."
                          :on-success (fn [] (re-frame/dispatch [:router/nav-to post-update-nav-to-url]))}])
                       (re-frame/dispatch
                        [update-questionnaire-event
                         (conj (cond-> %
                                 (false? ((nq :confidence-threshold-enabled?) %))
                                 (dissoc (nq :confidence-threshold)))
                               {:activity/uuid activity-uuid
                                :questionnaire/uuid ((nq :uuid) questionnaire)})
                         {:response-keys [:activity/uuid
                                          :questionnaire/uuid
                                          :questionnaire/pass-message
                                          :questionnaire/fail-message]
                          :on-success-toast questionnaire-success-toast
                          :on-failure-toast questionnaire-failure-toast}]))}}
       [:div
        [:div {:style {:max-width "600px"}}
         (rf/textarea
          {:field-key (nq :pass-message)
           :id :pass-message
           :label pass-label
           :default-value pass-message
           :validators []
           :transformers [t/trim]})]

        [:div {:style {:display :block
                       :margin-top (gs [:spacing :p40])
                       :margin-bottom (gs [:spacing :p20])}}
         [:hr {:style {:border :none
                       :border-top (str "1px solid "
                                        (gs [:colors :gray-scale-100]))}}]]
        
        (when (not= questionnaire-type :evaluation)
          [:div {:style {:max-width "600px"}}
           (rf/textarea
            {:field-key (nq :fail-message)
             :id :fail-message
             :label "Message presented after FAILING the test"
             :default-value fail-message
             :validators []
             :transformers [t/trim]})])

        (rf/submit-button
         {:default-text (if (false? messaging-confirmed?) "Confirm Messaging" "Update Messaging")})]]]]))
